// Safari 15.4-15.x has navigator.locks but not AbortSignal.timeout, which
// AuthKit uses to take its session lock. Without it every session restore
// fails and the user is sent back through sign-in on each page load.
export function installAbortSignalTimeout(): void {
  if (typeof AbortSignal.timeout === 'function') {
    return;
  }
  AbortSignal.timeout = (milliseconds: number) => {
    const controller = new AbortController();
    setTimeout(
      () => controller.abort(new DOMException('signal timed out', 'TimeoutError')),
      milliseconds,
    );
    return controller.signal;
  };
}
